import styled from 'styled-components';

export const SuccessCSS = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    color: var(--gray200);
  }

  i.big.icon {
    color: var(--gray200);
  }

  .ui.button {
    margin: 0;
    margin-top: 1rem;
  }
`;